/**
 * External dependencies
 */
import { Schema } from '@/types';
import { PocketBaseTS } from 'pocketbase-ts';

const pb = new PocketBaseTS<Schema>(process.env.REACT_APP_POCKETBASE_URL);

export default pb;
